import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import {
  setStep,
} from '../duck/activeStep';
import {
  Step,
} from 'semantic-ui-react';
import {
  rentersValid,
} from '../helpers/renterSchema';

import { addressValid } from '../helpers/addressSchema';

const Nav = (props) => {
  const { renter } = props;
  // let rentersComplete = false;

  let addressComplete = addressValid(props.address);
  let rentersComplete = rentersValid(props.renter, props.coRenter);

  let docsComplete = false;
  let docsToCheck = [
    // props.voidedCheck,
    props.driversLicense,
    props.proofOfIncome,
    props.proofOfResidence,
  ];

  if (props.coRenter) {
    docsToCheck.push(
      props.coRenter.drivers_license_image,
      props.coRenter.proof_of_income_image,
      props.coRenter.proof_of_residence_image,
    );
  }

  if (!docsToCheck.includes(null)) {
    docsComplete = true;
  }

  const steps = [
    // {
    //   key: 'dealer',
    //   icon: !props.dealer ? 'building outline' : 'check',
    //   completed: props.dealer ? true : false,
    //   title: 'Dealer',
    //   onClick: e => props.setStep('dealer'),
    //   active: props.step == 'dealer',
    // },
    {
      key: 'systems',
      icon: 'box',
      title: 'Systems',
      completed: props.systems.length ? true : false,
      active: props.step == 'systems',
      onClick: e => props.setStep('systems'),
    },
    {
      key: 'term',
      icon: 'list alternate outline',
      title: 'Term',
      active: props.step == 'term',
      completed: props.term && addressComplete ? true : false,
      onClick: e => props.setStep('term'),
    },
    {
      key: 'renter',
      icon: 'user',
      title: 'Renter',
      active: props.step == 'renter',
      completed: rentersComplete,
      onClick: e => props.setStep('renter'),
    },
    {
      key: 'documents',
      icon: 'images outline',
      title: 'Documents',
      active: props.step == 'documents',
      onClick: e => props.setStep('documents'),
      completed: docsComplete,
    },
    {
      key: 'payment',
      icon: 'dollar',
      title: 'Payment',
      active: props.step == 'payment',
      onClick: e => props.setStep('payment'),
      completed: props.payment || props.paymentSkipped ? true : false,
    },
    {
      key: 'preview',
      icon: 'pencil',
      title: 'Preview',
      active: props.step == 'preview',
      onClick: e => props.setStep('preview'),
    }
  ];

  return (
    <Step.Group
      items={steps}
      fluid
      size="tiny"
    />
  )
}

const mapDispatchToProps = dispatch => ({
  setStep: step => dispatch(setStep(step))
})

function mapStateToProps(state) {
  return {
    address: state.address,
    coRenter: state.coRenter,
    dealer: state.dealer,
    driversLicense: state.driversLicense,
    id: state.id,
    payment: state.payment,
    paymentSkipped: state.paymentSkipped,
    proofOfIncome: state.proofOfIncome,
    proofOfResidence: state.proofOfResidence,
    renter: state.renter,
    salesperson: state.salesperson,
    step: state.activeStep,
    systems: state.systems,
    term: state.term.selected,
    // voidedCheck: state.voidedCheck,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Nav);

